import axiosInstance from './axiosInstance';

const deleteCard = async ({word, token}) => {
  try {
    const response = await axiosInstance.post(
      '/cards/delete', 
      {
        word: word
      },
      {
        headers: {
          Authorization: token,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error('Error posting data: ' + error.message);
  }
};

export {deleteCard};